<template>
    <v-container fluid tag="section" class="px-3">
        <!-- кнопка NewSim и модалка BEGIN -->
        <add-sim-modal
                :object_id.sync="object_id"
                @closeModal="closeModal"
        />
        <!-- кнопка NewSim и модалка END -->
        <v-row class="wrapper flex-nowrap">
            <!-- Кнопка настроки операторов BEGIN -->
            <div class="text-center operator-settings-wrapper">
                <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        bottom
                        left
                        nudge-left="8"
                        offset-x
                        origin="top right"
                        transition="scale-transition"
                >
                    <template v-slot:activator="{ on }">
                        <v-btn class="operator-settings-button" dark v-on="on" icon large>
                            <v-icon size="32">mdi-sim-alert</v-icon>
                        </v-btn>
                    </template>

                    <v-card class="ma-0 pa-4 px-2" style="width:400px">
                        <v-card-title
                                class="pa-0 mb-4 justify-center text-uppercase display-1 font-weight-bold"
                        >
                            <span>Операторы</span>
                        </v-card-title>

                        <v-data-table
                                :headers="operatorsHeaders"
                                :items="operatorsData"
                                hide-default-footer
                                style="min-width:auto"
                        >
                            <template v-slot:item.operator="{ item }">
                                <div class="text-overflow" :class="item.imgClass">
                                    <span class="display-1 font-weight-light">{{ item.operator }}</span>
                                </div>
                            </template>

                            <template v-slot:item.allUsers="{ item }">
                                <span class="display-1 font-weight-light">{{ item.allUsers }}</span>
                            </template>

                            <template v-slot:item.activeUsers="{ item }">
                                <span class="display-1 font-weight-light">{{ item.activeUsers }}</span>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-menu>
            </div>
            <!-- Кнопка настроки операторов END -->

            <!-- Левая колонка BEGIN -->
            <!--<v-col class="left-column py-0">
                <v-card class="tree w-100 mb-0">
                    <v-card-text class="card-tree pa-4 pt-10 pr-0">
                        <v-btn class="card-tree-title" color="primary">Оператор</v-btn>
                        &lt;!&ndash; дерево BEGIN &ndash;&gt;
                        <v-treeview
                                class="card-tree-content"
                                :items="treeItems"
                                item-key="id"
                                selectable
                                on-icon="mdi-eye-off"
                                off-icon="mdi-eye"
                                indeterminate-icon="mdi-bookmark-minus"
                                selected-color="grey darken-1"
                                v-model="tree"
                                :open="open"
                                open-on-click
                        >
                            <template v-slot:prepend="{ item }">
                                <v-icon
                                        v-if="!item.children"
                                        small
                                        class="pr-1"
                                        :class="{'red&#45;&#45;text': item.name == 'Неактивные', 'green&#45;&#45;text': item.name == 'Активные'}"
                                >mdi-phone
                                </v-icon>
                            </template>
                        </v-treeview>
                        &lt;!&ndash; дерево END &ndash;&gt;
                    </v-card-text>
                </v-card>
            </v-col>-->
            <!-- Левая колонка END -->

            <!-- Правая колонка BEGIN -->
            <!--<v-col class="right-column pa-0 mr-3">-->
            <v-col>
                <div class="tables mt-0">
                    <div>
                        <v-card-title class="table-title my-1 pa-0 text-overflow">
                            ООО Ремс (Контракт)
                            <v-avatar size="20" class="ml-4">
                                <img
                                        src="@/assets/img/sim_cards/kyivstar-logo.png"
                                        class="elevation-0"
                                />
                            </v-avatar>
                            <span class="ml-1 text-overflow">
                                Киевстар - 25шт,
                            </span>
                            <v-avatar size="20" class="ml-4">
                                <img
                                        src="@/assets/img/sim_cards/lifecell-logo.png"
                                        class="elevation-0"
                                />
                            </v-avatar>
                            <span class="ml-1 text-overflow">
                                Лайф - 10 шт,
                            </span>
                            <v-avatar size="20" class="ml-4">
                                <img
                                        src="@/assets/img/sim_cards/vodafone-logo.png"
                                        class="elevation-0"
                                />
                            </v-avatar>
                            <span class="ml-1 text-overflow">
                                Водафон - 15шт
                            </span>
                        </v-card-title>
                        <v-card class="ma-0 my-2 w-100">
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                    <tr>
                                        <th
                                                v-for="item in tableHeaders"
                                                :key="item"
                                                class="table-cell"
                                        >{{ item }}
                                        </th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    <tr v-for="item in tableData" :key="item.id">

                                        <!-- Статус -->
                                        <!--<td
                                                class="table-cell"
                                                :class="{'red&#45;&#45;text': item.status == 'Offline', 'green&#45;&#45;text': item.status == 'Online'}"
                                        >{{ item.status }}
                                        </td>-->
                                        <td class="table-cell" style="color: #1F813E;">
                                            <div v-if="item.fullcontact"
                                                 style="color: #5FA057;">
                                                Online
                                            </div>
                                            <div v-else
                                                 style="color: red;">
                                                Offline
                                            </div>
                                        </td>

                                        <!-- Оператор -->
                                        <td class="table-cell">
                                            <div class="text-overflow">
                                                <v-avatar size="20" class="mr-1">
                                                    <img v-if="item.type === 'lifecell'"
                                                         src="@/assets/img/sim_cards/lifecell-logo.png"
                                                         class="elevation-0"
                                                    />
                                                    <img v-if="item.type === 'vodafone'"
                                                         src="@/assets/img/sim_cards/kyivstar-logo.png"
                                                         class="elevation-0"
                                                    />
                                                    <img v-else
                                                         src="@/assets/img/sim_cards/kyivstar-logo.png"
                                                         class="elevation-0"
                                                    />
                                                </v-avatar>
                                                <span class="operator-title">Киевстар</span>
                                            </div>
                                        </td>

                                        <!-- Пользователь -->
                                        <td class="table-cell text-left">
                                            <div class="d-flex align-center text-capitalize">
                                                <!--<v-avatar size="32" class="mr-1">
                                                    <img :src="item.url" class="elevation-0"/>
                                                </v-avatar>-->
                                                <div>
                                                    <!--<p
                                                            class="text-overflow ma-0 td-max-width"
                                                    >{{ item.user }}</p>-->
                                                    <span
                                                            class="display-1 font-weight-bold"
                                                            @click="edit(item.id)"
                                                    >{{ item.fullname }}
                                                    </span>
                                                </div>
                                            </div>
                                        </td>

                                        <!-- Входящие -->
                                        <td class="table-cell">{{ item.incoming }}</td>

                                        <!-- Исходящие -->
                                        <td class="table-cell">{{ item.outgoing }}</td>

                                        <!-- Баланс -->
                                        <td class="table-cell">
                                                <span
                                                        :class="{'green--text': item.balance >= 0,
                                                                'red--text': item.balance < 0,}"
                                                >{{ item.balance }}</span>
                                        </td>

                                        <!-- Дата обновления -->
                                        <td class="table-cell">
                                            <time class="d-flex flex-column text-overflow">
                                                <span>{{ item.update }}</span>
                                                <span>{{ item.updateTime }}</span>
                                            </time>
                                        </td>
                                    </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </div>
                </div>
            </v-col>
            <!-- Правая колонка END -->
        </v-row>
    </v-container>
</template>

<script>
    import AddSimModal from './components/AddSimModal'

    import axios from 'axios'

    export default {
        name: 'SimCards',

        components: { AddSimModal },

        data: function () {
            return {
                open: ['public'],
                menu: false,
                tree: [],
                treeItems: [
                    {
                        id: 1, name: 'Все sim-карты', phone: 'phone',
                        children: [{ id: 2, name: 'Активные' }, { id: 3, name: 'Неактивные' }],
                    }, {
                        id: 4, name: 'KyivStar',
                        children: [{ id: 5, name: 'Активные' }, { id: 6, name: 'Неактивные' }],
                    }, {
                        id: 7, name: 'Vodafone',
                        children: [{ id: 8, name: 'Активные' }, { id: 9, name: 'Неактивные' }],
                    }, {
                        id: 10, name: 'LifeCell',
                        children: [{ id: 11, name: 'Активные' }, { id: 12, name: 'Неактивные' }],
                    },
                ],

                tableHeaders: ['Статус', 'Оператор', 'Пользователь', 'Входящие (мин)',
                    'Исходящие (мин)', 'Баланс (грн)', 'Дата обновления'],

                tableData: [
                    {
                        id: 1,
                        fullcontact: 'Online',
                        operator: 'lifecell',
                        user: 'Иванов Иван Иванович',
                        number: '+380951002003',
                        url: 'https://randomuser.me/api/portraits/men/11.jpg',
                        incoming: '25:32:00',
                        outgoing: '11:32:00',
                        balance: '-20.05',
                        update: '01.10.2019',
                        'updateTime': '10:12',
                    },
                ],
                operatorsHeaders: [
                    {
                        text: 'Оператор',
                        value: 'operator',
                        align: 'center',
                        class: 'display-1 font-weight-light',
                    },
                    {
                        text: 'Всего',
                        value: 'allUsers',
                        align: 'center',
                        class: 'display-1',
                        class: 'display-1 font-weight-light',
                    },
                    {
                        text: 'Активных',
                        value: 'activeUsers',
                        align: 'center',
                        class: 'display-1 font-weight-light',
                    },
                ],
                operatorsData: [
                    {
                        operator: 'Kyivstar',
                        imgClass: 'operator-img kyivstar',
                        allUsers: 20,
                        activeUsers: 10,
                    },
                    {
                        operator: 'Lifecell',
                        imgClass: 'operator-img lifecell',
                        allUsers: 30,
                        activeUsers: 15,
                    },
                    {
                        operator: 'Vodafone',
                        imgClass: 'operator-img vodafone',
                        allUsers: 5,
                        activeUsers: 3,
                    },
                ],

                // id - выбраного объекта:
                object_id: -1,
            }
        },

        methods: {
            /**
             * Получить список sippeers.
             */
            getListSippeers () {
                axios({
                    method: 'get',
                    url: process.env.VUE_APP_API_URL_PHONE + 'get-list-sim-card',
                }).then((response) => {

                    console.log(response.data)

                    this.tableData = response.data

                }).catch(error => alert(error))
            },

            edit( id ) {
                console.log('edit(): ' + id);

                this.object_id = id;

                //this.$emit('editing', id);
            },

            closeModal(){
                console.log('closeModal()');

                this.object_id = -1;

                this.getListSippeers();
            }
        },

        created () {

            console.log('created() -- SimCards')

            this.getListSippeers()
        },
    }
</script>

<style scoped>
    /* сетка */

    .wrapper {
        height: 100%;
    }

    /* левая колонка */

    .left-column {
        height: 100%;
        flex-grow: 0;
        flex-shrink: 0;
        min-width: 290px;
        max-width: 290px;
    }

    .tree {
        height: calc(100% - 30px);
        /* height: auto; */
    }

    .card-tree {
        position: relative;
        height: 100%;
    }

    .card-tree-title {
        position: absolute;
        top: -17px;
        width: calc(100% - 32px);
        min-height: 48px;
        font-size: 14px !important;
        margin: 0 !important; /* убираем лишние отступы у плашки "Оператор" в дереве */
    }

    .card-tree-content {
        height: 100%;
        width: 100%;
        overflow-y: auto; /* полоса прокрутки для дерева, в случае увеличения высоты */
        overflow-x: hidden;
    }

    /* правая колонка */

    .right-column {
        height: 100%;
        /* flex-grow: 1; */
        /* flex-shrink: 0; */
        /* min-width: 700px; */
        overflow-x: auto !important;
    }

    .tables {
        margin-top: 30px;
        border-radius: 4px;
        height: calc(100% - 30px);
    }

    .v-data-table {
        min-width: 650px;
    }

    /* таблицы */

    th:nth-child(3) {
        text-align: left !important;
    }

    .table-title {
        text-transform: uppercase;
        font-size: 14px;
        line-height: 1.3;
        color: #0051ff;
    }

    .table-title span {
        font-size: 12px;
        text-transform: capitalize;
        display: inline-block;
        font-weight: normal;
        color: initial;
        vertical-align: top; /* выравниваем строку по высоте */
        padding-top: 0px;
    }

    .table-cell {
        font-size: 12px;
        text-align: center !important;
    }

    .text-left {
        text-align: left !important;
    }

    .operator-title {
        color: #94bcff;
    }

    /* настройки операторов */

    .operator-settings-wrapper {
        position: fixed;
        top: 125px;
        right: 0;
        z-index: 998;
    }

    .operator-settings-button {
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 8px 0 0 8px;
        min-width: 65px;
        height: 52px;
    }

    /* медиазапросы */

    @media (max-width: 800px) {
        .wrapper {
            display: block;
            margin: 0; /* убираем отрицательные margin -12px */
        }

        .left-column {
            margin-left: -12px;
        }
    }

    /* лого оператора в настройках */

    .operator-img {
        display: flex;
        align-items: center;
    }

    .operator-img::before {
        content: '';
        width: 36px;
        height: 36px;
        border-radius: 4px;
        padding: 0;
        margin-right: 12px;
        background-color: #0051ff;
        background-size: contain;
        background-position: center;
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14),
        0 7px 10px -5px rgba(76, 175, 80, 0.4) !important;
    }

    .kyivstar.operator-img::before {
        background-image: url('../../../assets/img/sim_cards/kyivstar-logo.png');
    }

    .lifecell.operator-img::before {
        background-image: url('../../../assets/img/sim_cards/lifecell-logo.png');
    }

    .vodafone.operator-img::before {
        background-image: url('../../../assets/img/sim_cards/vodafone-logo.png');
    }
</style>
